import passport from './interfaces/passport';
import unifydata from './interfaces/unifydata';

import account from './interfaces/account';
import payorder from './interfaces/payorder';
import download from './interfaces/download';
import bookManage from './interfaces/bookManage';


export default {
    passport,
    unifydata,
    account,
    payorder,
    download,
    bookManage
}